module.exports = __webpack_public_path__ + "static/img/7.66d2b6d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/sp/7.png
// module id = tQWK
// module chunks = 0